import React, { useState } from 'react';
import axios from 'axios';
export default function AIPanel({ currentCode }) {
  const [model, setModel] = useState('openai/gpt-4');
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const send = async () => {
    if (!input) return;
    const userMsg = { role: 'user', content: input };
    const newMessages = [...messages, userMsg];
    setMessages(newMessages);
    setInput('');
    const res = await axios.post('/api/ai/chat', { modelId: model, messages: newMessages });
    const botMsg = res.data.choices?.[0]?.message || { role: 'assistant', content: '无响应' };
    setMessages([...newMessages, botMsg]);
  };
  const review = async () => {
    if (!currentCode) return alert('请先打开一个文件');
    const res = await axios.post('/api/review/cross', {
      code: currentCode, language: 'javascript',
      models: ['openai/gpt-4', 'claude/opus'],
      dimensions: ['security', 'performance']
    });
    alert('评审完成，查看控制台');
    console.log(res.data.report);
  };
  return (
    <div className="p-4">
      <h3 className="font-bold mb-2">AI 编程助手</h3>
      <select value={model} onChange={e => setModel(e.target.value)} className="w-full bg-gray-700 p-1 rounded mb-2">
        <option value="openai/gpt-4">GPT-4</option>
        <option value="openai/gpt-3.5">GPT-3.5</option>
        <option value="claude/opus">Claude Opus</option>
      </select>
      <button onClick={review} className="w-full bg-orange-600 py-1 rounded mb-4">双模型交叉评审当前文件</button>
      <div className="h-64 overflow-auto mb-2 bg-gray-900 p-2 rounded">
        {messages.map((m, i) => (
          <div key={i} className={m.role === 'user' ? 'text-blue-400' : 'text-green-400'}>
            <b>{m.role}:</b> {m.content}
          </div>
        ))}
      </div>
      <textarea value={input} onChange={e => setInput(e.target.value)} className="w-full bg-gray-700 p-2 rounded mb-2" rows={3} />
      <button onClick={send} className="w-full bg-purple-600 py-1 rounded">发送</button>
    </div>
  );
}
